import { render, staticRenderFns } from "./BaseFormDevice.vue?vue&type=template&id=2c4e155b&scoped=true"
import script from "./BaseFormDevice.vue?vue&type=script&lang=js"
export * from "./BaseFormDevice.vue?vue&type=script&lang=js"
import style0 from "./BaseFormDevice.vue?vue&type=style&index=0&id=2c4e155b&prod&scoped=true&lang=css"
import style1 from "./BaseFormDevice.vue?vue&type=style&index=1&id=2c4e155b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e155b",
  null
  
)

export default component.exports